// constants
const GAME_WIDTH = 853;
const GAME_HEIGHT = 480;
const GROUND_HEIGHT = GAME_HEIGHT / 2 - 50;
const SPELL_COSTS = {
  SPELL: 10,
  RAISE: 25,
};
const MANA_REGEN = 2;
const DIRECTION = {
  LEFT: 1,
  RIGHT: 2,
};
const MELEE_RANGE = 25;
const ITEMS = {
  MANA: 1,
  POWERUP: 2,
  HEAL: 3,
  EXTRA_LIFE: 4,
};
const PLAYER_SPEED = 4;
const REST_COUNTDOWN = 10;
const BOSS_FREQUENCY = 5;
const RANDOM_TIPS = [
  "Your skeletons heal after every wave",
  "When you are powered-up your spells will do double the damage",
  "Don't waste your mana",
  "Leave the fire button pressed to charge your spells. They make double damage."
];
const randomValues = [ // precalculated random values to improve particle system performance
  0.4633453759376802,
  0.3290444674547941,
  0.2551377285002083,
  0.3925806814456123,
  0.44083789970736453,
  0.2508542930829436,
  0.08559908206545797,
  0.1224874605055859,
  0.7832021428283582,
  0.15237807489561783,
  0.042069899719877624,
  0.8228332993495342,
  0.3071917997519271,
  0.0638853965131847,
  0.8785905531071037,
  0.4806562120751683,
  0.6249982137681622,
  0.005407917112624228,
  0.45252536855235315,
  0.04846423809571587,
  0.6212828013754661,
  0.5648902673140885,
  0.9167365903267486,
  0.5317640239701051,
  0.1722441085559141,
  0.6633383100439079,
  0.3103321542604778,
  0.7012486854293654,
  0.1771608375401199,
  0.8679822985636243
];

// GAME STATES
const STATES = {
    TITLE: 0,
    RUNNING: 1,
    WIN: 2,
    LOSE: 3,
    PAUSED: 4,
  };

const SKELETON_GREETINGS = [
    "Yes, master",
    "Death shall reign",
    "My fate is sealed",
    "You called me?",
    "As you order!",
    "Yes?"
];
